/* eslint-disable */
import React, { useState, useContext } from 'react';
import { AuthContext } from '../../../auth/AuthContext';
import { signIn } from '../../../services/login';
import * as transactionService from '../../../services/transaction';
import logo from '../../../assets/logofinance.png';

import {
    Card,
    CardHeader,
    CardBody,
    CardActions
} from '@progress/kendo-react-layout';

import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { Label } from '@progress/kendo-react-labels';

import './styles.css';

export default function Auth() {
    const { setUser } = useContext(AuthContext);

    const [form, setForm] = useState({ Email: '', Senha: '' });
    const [jsonBody, setJsonBody] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const exportToFile = (data) => {
        const json = JSON.stringify(data, null, 2);
        const blob = new Blob([json], { type: "application/json" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Saldos.json";
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        let parsedBody = {};

        if (jsonBody.trim() !== '') {
            try {
                parsedBody = JSON.parse(jsonBody);
            } catch (err) {
                setError("JSON inválido: " + err.message);
                return;
            }
        }

        try {
            setLoading(true);

            await signIn(form, setUser);

            const { data } = await transactionService.exportBalance(parsedBody);

            if (!data) {
                setError("Nenhum dado retornado da API");
                return;
            }

            exportToFile(data);

        } catch (err) {
            console.error(err);
            setError('Erro ao logar ou exportar dados');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="export-bg">
            <Card className="export-card">
                <CardHeader className="export-header">
                    <img src={logo} alt="Logo" className="export-logo" />
                    <h2>Exportar Saldos</h2>
                </CardHeader>

                <CardBody>
                    <form onSubmit={handleSubmit} className="export-form">

                        <div className="export-input">
                            <Label>E-mail</Label>
                            <Input
                                name="Email"
                                value={form.Email}
                                onChange={handleChange}
                                autoComplete="off"
                            />
                        </div>

                        <div className="export-input">
                            <Label>Senha</Label>
                            <Input
                                type="password"
                                name="Senha"
                                value={form.Senha}
                                onChange={handleChange}
                                autoComplete="off"
                            />
                        </div>

                        <div className="export-input">
                            <Label>JSON</Label>
                            <textarea
                                rows={14}
                                style={{
                                    width: '100%',
                                    fontFamily: 'monospace',
                                    whiteSpace: 'pre-wrap',
                                    wordWrap: 'break-word',
                                    padding: '10px',
                                    fontSize: '14px',
                                    borderRadius: '6px',
                                    border: '1px solid #c4c4c4'
                                }}
                                value={jsonBody}
                                onChange={(e) => setJsonBody(e.target.value)}
                            />

                        </div>

                        {error && <p className="export-error">{error}</p>}

                        <CardActions>
                            <Button
                                type="submit"
                                disabled={loading}
                                className="export-btn"
                            >
                                {loading ? 'Processando...' : 'Exportar'}
                            </Button>
                        </CardActions>

                    </form>
                </CardBody>
            </Card>
        </div>
    );
}
